import { ChangeDetectorRef, Component, Input, OnInit, HostListener, ElementRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { filter } from 'rxjs/operators';
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { ProtocoloArquivo, StatusProtocolo } from 'src/app/model/protocolo-arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { ExportService } from 'src/app/shared/services/export.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';



@Component({
    selector: 'app-protocolo-renuncia-pesquisa',
    templateUrl: './protocolo-renuncia-pesquisa.component.html',
    styleUrls: ['./protocolo-renuncia-pesquisa.component.scss'],
    standalone: false
})
export class ProtocoloRenunciaPesquisaComponent implements OnInit {

    pesquisaForm: UntypedFormGroup;
    cnpjUsuario: string;
    cnpjSelecionado: string;
    statusSelecionado: StatusProtocolo;

    pesquisado: boolean; // usado no html
    public esconderPesquisa: boolean;
    agentesFinanceiros: AgenteFinanceiro[] = [];
    podeEscolherAgente = false;
    protocolosRenuncia: ProtocoloArquivo[];
    public exibirComboTipoArquivo: Boolean = false;
    private atributosPaginacaoComponenteListagem: EntityPagedResult<ProtocoloArquivo>;
    private opcoesPaginacao: number[];
    private paramsAdicionados: any = {};

    private totalObjetosRetornados: number;


    constructor(
        private formBuilder: UntypedFormBuilder,
        private permissaoService: PermissaoService,
        private loadingService: BnLoadingService,
        private service: ProtocoloArquivoService,
        private agenteService: AgenteFinanceiroService,
        private bnUsuarioService: BnUsuarioService,
        private exportService: ExportService,
        private el: ElementRef

    ) {

    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
        this.buscar(false, true)
    }

    ngOnInit(): void {

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
        });

        this.bnUsuarioService.usuario$.pipe(
            filter(usuario => !!usuario)
        ).subscribe(usuario => {
            this.cnpjUsuario = usuario.cnpj ? usuario.cnpj : 'BNDES';
            console.log(this.cnpjUsuario);
        });

        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.pesquisado = undefined;
        this.esconderPesquisa = false

        this.construirFormulario();
        this.buscarAgentesFinanceiros();
    }

    private construirFormulario() {
        this.pesquisaForm = this.formBuilder.group({
            agenteFinanceiro: [''],
            statusProtocolo: [''],
            dataEnvioInicial: [''],
            dataEnvioFinal: [''],
        });
    }

    private buscarAgentesFinanceiros() {
        this.agenteService.getAgentesFinanceirosNestaModalidade(true)
            .subscribe(agentes => {
                this.agentesFinanceiros = agentes;
            });
    }

    podePesquisar(): boolean {
        return true;
    }

    mudancaPagina(novaPagina: EntityPagedResult<ProtocoloArquivo>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscar(false, false);
    }


    compararPorId(item1: string, item2: string): boolean {
        return (item1 && item2) ? (item1 === item2) : (!item1 && !item2);
    }



    buscar(paginaVazia: boolean, voltarPagina1: boolean) {
        this.loadingService.bloqueiaTela();
        this.esconderPesquisa = true;


        const nomeAgenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;

        if (!nomeAgenteFinanceiro && !this.cnpjUsuario) {
            return;
        }

        let agenteFinanceiro;
        if (this.podeEscolherAgente) {
            agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.nome === nomeAgenteFinanceiro)[0];
        } else {
            agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
        }

        const tipoProtocolo = "9" // Solicitação da Renúncia à Cobertura Máxima de Inadimplência"

        const statusProtocolo = this.pesquisaForm.get('statusProtocolo')?.value;

        const apenasValidacao = undefined;

        const dataEnvioInicial: Date = this.pesquisaForm.get('dataEnvioInicial')?.value;
        const dataEnvioFinal: Date = this.pesquisaForm.get('dataEnvioFinal')?.value;

        /* preenchimento dos filtros */
        const params: any = {};

        if (agenteFinanceiro) {
            params.cnpjAgente = agenteFinanceiro.cnpj;
        }

        if (statusProtocolo) {
            params.statusProtocolo = statusProtocolo;
        }

        if (apenasValidacao !== undefined) {
            params.apenasValidacao = apenasValidacao;
        }

        if (dataEnvioInicial) {
            params.dataEnvioInicial = moment(dataEnvioInicial).format('YYYYMMDD');
        }

        if (dataEnvioFinal) {
            params.dataEnvioFinal = moment(dataEnvioFinal).format('YYYYMMDD');
        }

        params.tiposProtocolos = tipoProtocolo;

        if (voltarPagina1) {
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        paginaVazia = Utils.verificaPaginaVazia(this.protocolosRenuncia, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
            this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
        }
        params.pagina = this.atributosPaginacaoComponenteListagem.page;
        params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        this.paramsAdicionados = params;

        this.service.getArquivosPorAgente(params)
            .subscribe(response => {
                console.log(response);
                this.protocolosRenuncia = response ? response.resultados : undefined;
                this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
                this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
                this.pesquisado = true;
                this.esconderPesquisa = false;
                this.cnpjSelecionado = agenteFinanceiro?.cnpj;
                this.loadingService.liberaTela();

                paginaVazia = Utils.verificaPaginaVazia(this.protocolosRenuncia, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
                if (paginaVazia && !voltarPagina1) {
                    this.buscar(false, true);
                }
            }, err => this.loadingService.liberaTela());
    }

    removeNgInvalidInput(id: string) {
        const inputElement = this.el.nativeElement.querySelector(`#${id}`);
        inputElement.classList.remove('ng-invalid');
      }


    limpar() {

        this.pesquisado = undefined;

       if(this.cnpjUsuario === 'BNDES'){
          this.pesquisaForm.reset();
          this.pesquisaForm.get('agenteFinanceiro').setValue(undefined);
       }

        this.pesquisaForm.get('statusProtocolo').setValue(undefined);
        this.pesquisaForm.get('dataEnvioInicial').setValue(undefined);
        this.pesquisaForm.get('dataEnvioFinal').setValue(undefined);

        setTimeout(() => {
            this.removeNgInvalidInput('dataEnvioInicial');
            this.removeNgInvalidInput('dataEnvioFinal');
          }, 100);

    }


    getParams(comDetalhes?: boolean): any {


        if (comDetalhes) {
            this.paramsAdicionados.comDetalhes = true;
            this.paramsAdicionados.limite = 5000;
            this.paramsAdicionados.pagina = 1;
        }

        return this.paramsAdicionados;
    }


   exportarProtocolosRenuncia() {
        this.loadingService.bloqueiaTela();
        this.service.getArquivosPorAgente(this.getParams(true)).subscribe((resp) => {
           console.log(resp);
            this.exportService.exportarListaProtocolosRenuncia(resp);
        });
    }


}
